import React, { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import '../styles-v2/Navbar.css';
import tuLogo from '../Image/out-foulder-img/logo.jpg';
import i18n from './i18n';

const Navbar = ({ isScrolled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { lang } = useParams();

    // Idioma actual: URL > i18n > default 'es'
    const currentLang = lang || i18n.language || 'es';

    const navbarClasses = `navbar ${isScrolled ? 'scrolled' : ''}`;

    // Función para cambiar idioma y actualizar la URL
    const cambiarIdioma = (nuevoLenguaje) => {
        // 1. Obtenemos la ruta actual sin el idioma (ej: de "/es" sacamos "")
        const pathSegments = location.pathname.split('/');
        const currentPathAfterLang = pathSegments.slice(2).join('/');

        // 2. Navegamos a la nueva URL (ej: /en/ + ruta_actual)
        navigate(`/${nuevoLenguaje}/${currentPathAfterLang}`);

        // 3. Cambiamos el idioma en i18next
        i18n.changeLanguage(nuevoLenguaje);

        setIsOpen(false); // Cerramos menú móvil
    };

    return (
        <nav className={navbarClasses}>
            {/* Logo: Al clickear, vuelve al inicio del idioma actual */}
            <HashLink smooth to={`/${currentLang}#home`}>
                <img src={tuLogo} alt="Protego Logo" className="navbar-logo" />
            </HashLink>

            {/* Botón hamburguesa */}
            <div
                className={`hamburger ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Links */}
            <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
                {/* Usamos HashLink smooth para el scroll fluido */}
                <HashLink smooth to={`/${currentLang}#home`} onClick={() => setIsOpen(false)}>
                    {t('navbar.home')}
                </HashLink>
                <HashLink smooth to={`/${currentLang}#nosotros`} onClick={() => setIsOpen(false)}>
                    {t('navbar.about')}
                </HashLink>
                <HashLink smooth to={`/${currentLang}#servicios`} onClick={() => setIsOpen(false)}>
                    {t('navbar.services')}
                </HashLink>
                <HashLink smooth to={`/${currentLang}#noticias`} onClick={() => setIsOpen(false)}>
                    {t('navbar.news')}
                </HashLink>
                <HashLink smooth to={`/${currentLang}#contacto`} onClick={() => setIsOpen(false)}>
                    {t('navbar.contact')}
                </HashLink>

                {/* Selector de Idioma */}
                <div className="language-switch">
                    <button
                        onClick={() => cambiarIdioma('es')}
                        className={currentLang.startsWith('es') ? 'active-lang' : ''}
                        style={{
                            marginRight: '10px',
                            cursor: 'pointer',
                            background: 'transparent',
                            border: 'none',
                            color: 'inherit',
                            fontWeight: currentLang.startsWith('es') ? 'bold' : 'normal'
                        }}
                    >
                        ES
                    </button>
                    <span>|</span>
                    <button
                        onClick={() => cambiarIdioma('en')}
                        className={currentLang.startsWith('en') ? 'active-lang' : ''}
                        style={{
                            marginLeft: '10px',
                            cursor: 'pointer',
                            background: 'transparent',
                            border: 'none',
                            color: 'inherit',
                            fontWeight: currentLang.startsWith('en') ? 'bold' : 'normal'
                        }}
                    >
                        EN
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;